export default __webpack_public_path__ + "static/media/baby-1.53903560.svg";